import { CustomerInput } from "@smartrr/shared/shopifyGraphQL/api";
import { IShopifyLiquidCustomer } from "@smartrr/shared/shopifyLiquid/customer";
import { ICustomerPortalValidationObj } from "@smartrr/shared/shopifyLiquid/validation";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import { toast } from "react-toastify";

import { typedCustomerFrontendApi } from "@customer-app/shared/typedCustomerFrontendApi";
import { customerAsyncDispatch } from "@customer-app/state/customerAsyncDispatch";
import { CustomerAction, CustomerThunkAction } from "@customer-app/state/typedCustomerRedux";

export const setLiquidCustomer = (
  liquidCustomer: IShopifyLiquidCustomer
): CustomerAction<"SET_LIQUID_CUSTOMER"> => ({
  type: "SET_LIQUID_CUSTOMER",
  payload: { liquidCustomer },
});

export const setLiquidValidation = (
  liquidValidation: ICustomerPortalValidationObj
): CustomerAction<"SET_LIQUID_VALIDATION"> => ({
  type: "SET_LIQUID_VALIDATION",
  payload: { validation: liquidValidation },
});

export const loadCustomer =
  (): CustomerThunkAction<"LOADING_SESSION" | "LOADING_SESSION_ERROR" | "LOADED_SESSION"> => dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.getReq("/auth/session"),
      () =>
        dispatch({
          type: "LOADING_SESSION",
          payload: undefined,
        }),
      failure =>
        dispatch({
          type: "LOADING_SESSION_ERROR",
          payload: {
            errorMessage: failure.message,
          },
        }),
      ({ customerRelationship, organization }) =>
        dispatch({
          type: "LOADED_SESSION",
          payload: {
            customerRelationship,
            organization,
          },
        })
    );

export const upsertAndLoadCustomer =
  (
    liquidCustomer: IShopifyLiquidCustomer
  ): CustomerThunkAction<"LOADING_SESSION" | "LOADING_SESSION_ERROR" | "LOADED_SESSION"> =>
  dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.postReq("/auth/session", {
        reqBody: {
          liquidCustomer,
        },
      }),
      () =>
        dispatch({
          type: "LOADING_SESSION",
          payload: undefined,
        }),
      failure =>
        dispatch({
          type: "LOADING_SESSION_ERROR",
          payload: {
            errorMessage: failure.message,
          },
        }),
      ({ customerRelationship, organization }) =>
        dispatch({
          type: "LOADED_SESSION",
          payload: {
            customerRelationship,
            organization,
          },
        })
    );

export const changeCustomerInformation =
  (
    customerInfoBody: CustomerInput,
    staleCustomerInfoBody?: CustomerInput // to be used for event logging
  ): CustomerThunkAction<
    | "CHANGING_CUSTOMER_INFORMATION"
    | "CHANGING_CUSTOMER_INFORMATION_SUCCESS"
    | "CHANGING_CUSTOMER_INFORMATION_ERROR"
  > =>
  dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.postReq("/customer/change-info", {
        reqBody: { customerInfoBody, staleCustomerInfoBody },
      }),
      () =>
        dispatch({
          type: "CHANGING_CUSTOMER_INFORMATION",
          payload: undefined,
        }),
      failure => {
        toast.error(typedLocalize("settings.personalInformation.emailUpdateError"));

        return dispatch({
          type: "CHANGING_CUSTOMER_INFORMATION_ERROR",
          payload: {
            errorMessage: failure.message,
          },
        });
      },
      customer => {
        toast(typedLocalize("settings.personalInformation.emailUpdated"));

        return dispatch({
          type: "CHANGING_CUSTOMER_INFORMATION_SUCCESS",
          payload: { customer },
        });
      }
    );
